import { TranslationKey, useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ButtonWithLoader } from '../../../../design/buttons/ButtonWithLoader';
import { S_ErrorFeedback } from '../../../../design/feedback/errorFeedback/S_ErrorFeedback';
import { Select } from '../../../../design/inputs/select/Select';
import { S_TextInput } from '../../../../design/inputs/textInput/S_TextInput';
import { S_FieldLabel } from '../../../../design/labels/fieldLabel/S_FIeldLabel';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';
import { Plan } from '../../user/user.store';
import { WorkspaceRole } from '../../workspaces/workspaces.store';
import { rolesPossibleToAssign } from './AddTeamMember';

interface IChangeUserRoleModalProps {
  userNameSelectedToChange: string;
  changeUserRoleModalShown: boolean;
  userSelectedToChange: string;
  selectedChangeRole: WorkspaceRole;
  changeRoleError: TranslationKey;
  onChange: () => Promise<void>;
  onToggleChangeUserRoleModal: (email: string) => void;
  onChangeRoleSelected: (role: WorkspaceRole) => void;
  currentPlan: Plan;
}

export const ChangeUserRoleModal = observer((props: IChangeUserRoleModalProps): ReactElement => {
  const { t } = useTranslator();

  const handleChangeRoleSelected = (value: WorkspaceRole): void => {
    props.onChangeRoleSelected(value);
  };

  const toggleChangeUserRoleModal = (): void => {
    props.onToggleChangeUserRoleModal('');
  };

  const options = rolesPossibleToAssign.map((r) => ({ value: r, label: t(r) }));

  return (
    <S_Modal
      isOpen={props.changeUserRoleModalShown}
      toggle={toggleChangeUserRoleModal}
      headerText={t('reassign_user_role')}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={toggleChangeUserRoleModal}
          >
            {t('cancel')}
          </Button>
          <ButtonWithLoader
            onClick={props.onChange}
            loaderKey='change-user-role-button'
          >
            {t('save')}
          </ButtonWithLoader>
        </>
      }
    >
      <div>
        <S_FieldLabel>{t('name')}</S_FieldLabel>
        <S_TextInput
          value={props.userNameSelectedToChange}
          disabled={true}
        />
      </div>
      <div>
        <S_FieldLabel>{t('email')}</S_FieldLabel>
        <S_TextInput
          value={props.userSelectedToChange}
          disabled={true}
        />
      </div>
      <div>
        <S_FieldLabel>{t('role')}</S_FieldLabel>
        <Select
          id='user-change-role-dropdown'
          value={options.find((x) => x.value === props.selectedChangeRole)}
          onChange={(_, v) => {
            handleChangeRoleSelected(v.value ?? WorkspaceRole.None);
          }}
          options={options}
        />
        <div className='change-role-error'>
          {props.changeRoleError && <S_ErrorFeedback>{t(props.changeRoleError, { plan: t(props.currentPlan) })}</S_ErrorFeedback>}
        </div>
      </div>
    </S_Modal>
  );
});
